
	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { ContactMessage, ContactReason } from '@shared/models';
	import AboutMenu from '@client/views/common/AboutMenu.vue';
	import RecentEntries from '@client/views/blog/RecentEntries.vue';

	@Component({
		components: {
			RecentEntries,
			AboutMenu,
		},
	})
	export default class Contact extends BaseView {

		public reasons: ContactReason[] = [];
		public message: ContactMessage = new ContactMessage();

		/** Fires when this component is loaded. */
		public async mounted() {
			this.loading = true;
			try {
				this.reasons = await this.$api.contactReasonService.list();
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading contact reasons');
			} finally {
				this.loading = false;
			}
		}

		public async send() {
			this.loading = true;
			try {
				const result = await this.$api.contactMessageService.save(this.message);
				this.notification.success('Your message has been sent successfully. Thanks for reaching out!');
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while sending this message');
			} finally {
				this.loading = false;
			}
		}

	}

